import { CharacterFactory } from "./CharacterFactory";
import { warriorConfig } from "./definitions/warrior";
import { barbarianConfig } from "./definitions/barbarian";

// Register all characters
CharacterFactory.register(warriorConfig);
CharacterFactory.register(barbarianConfig);

// Re-export everything for convenience
export { CharacterFactory } from "./CharacterFactory";
export type { CharacterConfig, CharacterId } from "./types";
export { warriorConfig } from "./definitions/warrior";
export { barbarianConfig } from "./definitions/barbarian";
